module.exports = "../images/icons/bank.svg";